export const testimonials = [
  {
    name: 'Mariana S.',
    role: 'Physiotherapist, 34 — Private Practice',
    initials: 'MS',
    quote:
      'Most of my caseload is neck and shoulder work. Volume 01 gives me positioning, hand placement and a matching exercise for every technique — my sessions finally have a clear structure.',
  },
  {
    name: 'Robert K.',
    role: 'Physical Therapist, 47 — Orthopedic Clinic',
    initials: 'RK',
    quote:
      'I didn’t need more techniques, I needed structure. The 30-minute knee templates show exactly how to split manual work, exercise and reassessment. No more starting from a blank page.',
  },
  {
    name: 'Elena V.',
    role: 'Manual Therapist, 39 — Spine & Pelvis Focus',
    initials: 'EV',
    quote:
      'Volume 02 is the reference I open most. Together with the screening checklists from Bonus 01, I feel much better prepared before every new patient.',
  },
  {
    name: 'Thomas G.',
    role: 'Upper-Limb Rehab Specialist, 42',
    initials: 'TG',
    quote:
      'Good forearm and hand resources are hard to find. Volume 03 covers it all, and the printable home handouts saved me hours of writing instructions.',
  },
  {
    name: 'Natalia R.',
    role: 'Physiotherapist & Clinic Owner, 45',
    initials: 'NR',
    quote:
      'With four therapists on my team, consistency was the challenge. The session builder and progression planners became our shared framework.',
  },
]
